import {PERIODIC_DEPOSIT_STATUS_TO_DV_MAPPING} from '@/constants/engine';
import {DomainValueReference} from '@/model/types';

export const mapPeriodicDepositStatusToDomainValue = (statusCode?: string): DomainValueReference | null => {
  if (!statusCode || !(statusCode in PERIODIC_DEPOSIT_STATUS_TO_DV_MAPPING)) return null;

  return {
    $ref: PERIODIC_DEPOSIT_STATUS_TO_DV_MAPPING[statusCode as keyof typeof PERIODIC_DEPOSIT_STATUS_TO_DV_MAPPING],
  };
};
